import React, { useRef, useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// CRO: Testimonials endorse Adam Sand as a technology consultant and innovator
// These are endorsements of Adam's expertise — NOT product reviews for RoofClaw

const testimonials = [
    {
        quote: "Adam has been supporting our business for over a year, implementing new technologies that keep us at the forefront and backing it up with training and guidance on innovation.",
        name: "Jack Divine",
        role: "Storm Restoration Contractor",
        stars: 5,
    },
    {
        quote: "We've worked with Adam for about two years. He implemented a full technology stack for us — field service, marketing innovations, reporting and dashboards, an inside sales system, automated site supervisor lead management, and an uber-like experience for our customers. I attended almost every webinar for two years and asked over 150 questions. He answered every one.",
        name: "Elmer Glick",
        role: "Roofing Business Owner",
        stars: 5,
    },
    {
        quote: "I first started working with Adam when I was 24, taking over the company from my father. Over six years we grew from six million in sales to 60, launching constant innovations and automations to further streamline our business. It simply wouldn't have been possible. \"Once a client, forever a friend\" is how I would describe our relationship.",
        name: "Brennan Leong",
        role: "Roofing Operations Lead",
        stars: 5,
    },
    {
        quote: "Innovation isn't easy and we did a pretty significant rollout with Adam Sand's technology across our entire company. Change management is a big task but we got a lot of support from him and his team and our revenue doubled. We also won Owens Corning Contractor of the Year that year. It's not for the faint of heart to take on big goals but Adam is the partner you want if you're going to do it.",
        name: "Dante Cantu",
        role: "Roofing Contractor",
        stars: 5,
    },
];

const StarRow = ({ count }) => (
    <div className="flex gap-1 mb-4">
        {Array.from({ length: count }).map((_, i) => (
            <span key={i} className="text-[#7B61FF] text-sm">★</span>
        ))}
    </div>
);

const Testimonials = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        let ctx = gsap.context(() => {
            gsap.from('.testimonial-card', {
                y: 30,
                opacity: 0,
                duration: 0.9,
                stagger: 0.12,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: 'top 80%',
                }
            });
        }, containerRef);
        return () => ctx.revert();
    }, []);

    return (
        <section ref={containerRef} className="py-24 md:py-32 px-6 md:px-16 bg-[#0A0A14] border-t border-[#7B61FF]/10">
            <div className="max-w-7xl mx-auto">
                <div className="mb-16 max-w-xl">
                    <p className="font-data text-[#7B61FF] text-xs tracking-widest uppercase mb-4">From the Field</p>
                    <h2 className="text-[#F0EFF4] font-bold text-4xl md:text-5xl tracking-tight">
                        What contractors say{' '}
                        <span className="font-drama text-[#7B61FF]">about working with Adam.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {testimonials.map((t, i) => (
                        <div
                            key={i}
                            className="testimonial-card bg-[#18181B] border border-[#7B61FF]/20 rounded-[2rem] p-8 flex flex-col"
                        >
                            <StarRow count={t.stars} />
                            <p className="text-[#F0EFF4]/80 text-base leading-relaxed mb-8 flex-1">
                                "{t.quote}"
                            </p>
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-[#7B61FF]/20 flex items-center justify-center">
                                    <span className="font-bold text-[#7B61FF] text-sm">{t.name[0]}</span>
                                </div>
                                <div>
                                    <p className="font-semibold text-[#F0EFF4] text-sm">{t.name}</p>
                                    <p className="text-[#F0EFF4]/40 text-xs">{t.role}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
